import React from 'react';
import { Tabs as AntTabs } from 'antd';

/**
 * Wrapper component for Ant Design Tabs
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Tabs functionality and sub-components.
 * 
 * @component
 * @example
 * import { Tabs } from '../GeneralComponents/ui';
 * 
 * <Tabs>
 *   <Tabs.TabPane tab="Tab 1" key="1">Content 1</Tabs.TabPane>
 *   <Tabs.TabPane tab="Tab 2" key="2">Content 2</Tabs.TabPane>
 * </Tabs>
 * 
 * @see https://ant.design/components/tabs/ - Ant Design Tabs documentation
 */
const Tabs = (props) => {
  return <AntTabs {...props} />;
};

// Preserve Tabs sub-components
Tabs.TabPane = AntTabs.TabPane;

export default Tabs;

